<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row dense>
            <v-col cols="12">
              <v-text-field v-model="form.nombre" label="Nombre" outlined dense hide-details clearable></v-text-field>

              <small v-for="error in errores.nombre" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12">
              <v-btn
                class="mx-1"
                color="primary"
                title="Agregar Concepto"
                small
                @click="$refs.modalFormularioPlanPagoConceptoUniversidadRef.abrir(accionesCrud.REGISTRAR, [])">
                <v-icon>mdi-plus</v-icon>

                Agregar Concepto
              </v-btn>
            </v-col>

            <v-col cols="12">
              <ListadoPlanesPagosConceptosUniversidades
                ref="listadoRef"
                :cargando="false"
                :items="form.planesPagosConceptosUniversidades"
                @selectItem="selectItem" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text :disabled="enviando" @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="enviando"
          :loading="enviando"
          @click.prevent="() => validar(registrar, editar)">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>

    <ModalFormularioPlanPagoConceptoUniversidad
      ref="modalFormularioPlanPagoConceptoUniversidadRef"
      nombreRecurso="Plan Pago Concepto Universidad"
      :universidadId="form.universidadId"
      @agregarPlanPagoConceptoUniversidad="agregarPlanPagoConceptoUniversidad" />
  </v-dialog>
</template>

<script>
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import layoutMixin from '../mixins/layout.mixin';
import PlanPagoUniversidadService from '../services/plan-pago-universidad.service';
import ListadoPlanesPagosConceptosUniversidades from './ListadoPlanesPagosConceptosUniversidades.vue';
import ModalFormularioPlanPagoConceptoUniversidad from './ModalFormularioPlanPagoConceptoUniversidad.vue';

export default {
  name: 'ModalFormularioPlanPagoUniversidad',
  mixins: [modalFormMixin, layoutMixin, apiConsumerMixin],
  components: {
    ListadoPlanesPagosConceptosUniversidades,
    ModalFormularioPlanPagoConceptoUniversidad,
  },
  props: {
    universidadId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {};
  },
  watch: {
    'form.nombre': function () {
      this.errores.nombre = [];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        nombre: null,
        universidadId: this.universidadId,
        planesPagosConceptosUniversidades: [],
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        nombre: data.nombre,
        universidadId: data.universidadId,
        planesPagosConceptosUniversidades: data.planesPagosConceptosUniversidades,
      };
    },
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
    },
    agregarPlanPagoConceptoUniversidad(planPagoConceptoUniversidad) {
      if (
        this.form.planesPagosConceptosUniversidades.findIndex(
          (plan) => plan.conceptoUniversidadId == planPagoConceptoUniversidad.conceptoUniversidadId,
        ) !== -1
      ) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'El concepto ya se encuentra agregado.',
          type: 'error',
        });

        return;
      }

      this.form.planesPagosConceptosUniversidades.push({
        ...planPagoConceptoUniversidad,
        orden: this.form.planesPagosConceptosUniversidades.length + 1,
      });
    },
    guardar(accion) {
      this.guardarDatosMixin(
        PlanPagoUniversidadService.create,
        () => {},
        accion,
        this.form,
        this.nombreRecurso,
        () => {
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
    registrar() {
      this.guardar(this.accionesCrud.REGISTRAR);
    },
    editar() {
      this.guardar(this.accionesCrud.EDITAR);
    },
  },
};
</script>